import { useParams } from 'react-router-dom'
import { getEmployee } from '../api'
import { useNotification, usePermissions } from 'hooks'
import { useState } from 'react'
import { InfoItems } from 'components/core-ui/InfoItems'
import s from './Employee.modules.scss'
import { Box, CircularProgress } from '@mui/material'
import { columns } from './helpers'
import { Table } from '@fullscreendigital/carrefour-dex-fe'
import { EditActionIcon } from 'icons'
import { roles } from '../constants'
import { Contract } from '../interfaces'
import { EmployeeModal } from './EmployeeModal'

const Employee = () => {
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [selectedRow, setSelectedRow] = useState<Contract>()
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)

  const { id } = useParams()

  const { showNotification } = useNotification()

  const { canEdit } = usePermissions(roles)

  const { data: employee, isLoading } = getEmployee(
    showNotification,
    +id,
    shouldRefreshData,
    setShouldRefreshData
  )

  const openEditModal = (): void => setIsEditModalOpen(true)
  const closeEditModal = (): void => setIsEditModalOpen(false)

  const selectRow = (rowId: number): void => {
    const item = employee?.contractList?.find(item => item.id === rowId)
    if (item) {
      setSelectedRow(item)
      openEditModal()
    }
  }

  return (
    <div className={s.mainContainer}>
      {isLoading ? (
        <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
      ) : (
        <>
          <InfoItems
            itemsPerRow={3}
            items={
              employee
                ? [
                    { name: employee.firstName, label: 'First name:' },
                    { name: employee.lastName, label: 'Last name:' },
                    { name: employee.emailAddress, label: 'Email:' },
                    { name: employee.adUserName, label: 'AD User Name:' },
                    { name: employee.globalId, label: 'Global ID:' },
                    { name: employee.userId, label: 'User ID:' },
                    { name: employee.userRoleList, label: 'Roles:' }
                  ]
                : []
            }
          />
          <Box className={s.sectionTitle}>Contracts</Box>
          {canEdit && (
            <EmployeeModal
              isModalOpen={isEditModalOpen}
              closeModal={closeEditModal}
              editItem={selectedRow}
              setShouldRefreshData={setShouldRefreshData}
            />
          )}
          <Table
            hideCheckbox={true}
            isLoading={false}
            columns={columns}
            rows={employee?.contractList || []}
            disablePagination
            rowActions={[
              canEdit && {
                label: 'Edit',
                labelColor: 'white',
                typographyVariant: 'medium',
                backgroundColor: '#16a085',
                desktopIcon: <EditActionIcon />,
                onClick: (_e, rowId) => selectRow(+rowId)
              }
            ]}
            rowActionsWidth="130px"
          />
        </>
      )}
    </div>
  )
}

export default Employee
